import { put, takeLatest } from 'redux-saga/effects';
import {
  SET_FAQ_CATEGORIES,
  GET_FAQ_CATEGORIES,
  SET_FAQ_QUESTIONS,
  GET_FAQ_QUESTIONS,
  GET_MOST_SEARCHED_FAQ,
  SET_MOST_SEARCHED_FAQ,
  GET_SEARCHED_FAQ,
  SET_SEARCHED_FAQ,
  GET_FAQ_ANSWER,
  SET_FAQ_ANSWER,
} from '../redux/action/types';
import { faqApi } from '../utils/api';

function* getFAQsCategories() {
  try {
    const faqCategories = yield faqApi.getFAQsCategories();
    yield put({
      type: SET_FAQ_CATEGORIES,
      data: faqCategories.data.categories,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getFAQs() {
  try {
    const faqs = yield faqApi.getFAQs();
    yield put({
      type: SET_FAQ_QUESTIONS,
      data: faqs.data.faqs,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getMostSearchedFAQsTerms(limitTerms) {
  try {
    const mostSearchedFaqs = yield faqApi.getMostSearchedFAQsTerms(limitTerms);
    yield put({
      type: SET_MOST_SEARCHED_FAQ,
      data: mostSearchedFaqs.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getSearchedFAQs(searchedTerm) {
  try {
    const searchedFaqs = yield faqApi.getSearchedFAQs(searchedTerm);
    yield put({
      type: SET_SEARCHED_FAQ,
      data: searchedFaqs.data.faqs,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getFAQsAnswer(faqId) {
  try {
    const faqAnswer = yield faqApi.getFAQsAnswer(faqId);
    yield put({
      type: SET_FAQ_ANSWER,
      data: faqAnswer.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* faqSaga() {
  yield takeLatest(GET_FAQ_CATEGORIES, getFAQsCategories);
  yield takeLatest(GET_FAQ_QUESTIONS, getFAQs);
  yield takeLatest(GET_MOST_SEARCHED_FAQ, getMostSearchedFAQsTerms);
  yield takeLatest(GET_SEARCHED_FAQ, getSearchedFAQs);
  yield takeLatest(GET_FAQ_ANSWER, getFAQsAnswer);
}

export default faqSaga;
